var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { PasswordInput, required, SimpleForm, TextInput, useLogin, useTranslate, } from 'react-admin';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { makeStyles, Link, Typography } from '@material-ui/core';
import get from 'lodash/get';
import { AuthSchemeList, LoginToolbar } from '.';
import { useAuthSchemes, usePasswordEncryption } from '..';
export const LoginForm = props => {
    const { toolbarProps } = props, rest = __rest(props, ["toolbarProps"]);
    const login = useLogin();
    const classes = useStyles(rest);
    const translate = useTranslate();
    const location = useLocation();
    const [authSchemes, defaultAuthScheme, defaultEnhancedPasswordSecurity,] = useAuthSchemes(location);
    const [publicKey, encrypt] = usePasswordEncryption();
    const [isLoading, setIsLoading] = useState(null);
    const [error, setError] = useState(null);
    const [authScheme, setAuthScheme] = useState(null);
    const submit = async ({ username, password }) => {
        setError(null);
        setIsLoading(true);
        const params = {
            scheme: 'credentials',
            provider: get(authScheme, 'uuid', null),
            username,
            password,
        };
        const enhancedPasswordSecurity = authScheme
            ? get(authScheme, 'advancedConfigurations.enhancedPasswordSecurity') === 'yes'
            : defaultEnhancedPasswordSecurity;
        if (enhancedPasswordSecurity && publicKey) {
            params.password = await encrypt(password);
            params.publicKey = publicKey;
        }
        try {
            await login(params);
        }
        catch (_a) {
            setError('apihub.login.notifications.invalid_credentials');
        }
        setIsLoading(false);
    };
    if (defaultAuthScheme && !defaultAuthScheme.credsReqd) {
        window.location = defaultAuthScheme.url;
        return;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(SimpleForm, Object.assign({ className: classes.form, save: submit, toolbar: React.createElement(LoginToolbar, Object.assign({ loading: isLoading, error: error }, toolbarProps)) }, props),
            React.createElement(TextInput, { source: "username", type: "text", label: "apihub.login.fields.username", variant: "outlined", fullWidth: true, validate: required() }),
            React.createElement(PasswordInput, { source: "password", label: "apihub.login.fields.password", variant: "outlined", fullWidth: true, validate: required() })),
        React.createElement(Typography, { variant: "body1" },
            React.createElement(Link, { component: RouterLink, to: "/reset-password" }, translate('apihub.login.actions.forgot_password'))),
        authSchemes.length > 0 ? (React.createElement(AuthSchemeList, { onClick: setAuthScheme, authSchemes: authSchemes })) : null));
};
const useStyles = makeStyles(theme => ({
    form: {
        '& >:first-child': {
            padding: 0,
        },
    },
}), {
    name: 'Layer7LoginForm',
});
//# sourceMappingURL=LoginForm.js.map